import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../app/helper/auth.guard';
import { VerificationTokenComponent } from './page/verification/verificationtoken.component';
const routes: Routes = [
  {
    path: '',
    redirectTo: '/weblogin',
    pathMatch: 'full'
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'validateUser/:token', component: VerificationTokenComponent,
    data: { title: 'Reset Password', allowedRoles: [], showPreHeader: true, showPreFooter: true, showPostHeader: false, showPostFooter: false, showSidebar: false }
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/home/home.module').then(m => m.HomeModule),
    data: { title: 'Home', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: true, showSidebar: true }
  }
  ,
  {
    path: 'users',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/viewusers/viewusers.module').then(m => m.ViewUsersModule),
    data: { title: 'Users', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: true, showSidebar: true }
  }
  ,
  {
    path: 'assignuserrole',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/userrole/userrole.module').then(m => m.UserRoleModule),
    data: { title: 'Assign UserToRole', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: true, showSidebar: true }
  }
  ,
  {
    path: 'assignroleauthority',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/roleauthority/roleauthority.module').then(m => m.RoleAuthorityModule),
    data: { title: 'Assign RoleAuthority', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: true, showSidebar: true }
  }
 

  ,
  {
    path: 'myprofile',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/updateuser/updateuser.module').then(
        m => m.UpdateUserModule
      ),
    data: {
      title: 'MyProfile', showPreHeader: false, showPostHeader: true, showPostFooter: true, showSidebar: true
    }
  }
  ,

  {
    path: 'changepasswordlink',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/changepassword/changepassword.module').then(
        m => m.ChangePasswordModule
      ),
    data: {
      title: 'Change Password', showPreHeader: false, showPostHeader: true, showPostFooter: true, showSidebar: true
    }
  }
  ,

  {
    path: 'logout',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/weblogin/weblogin.module').then(
        m => m.WebLoginModule
      ),
    data: {
      title: 'Logout', showPreFooter: true, showPreHeader: true, showPostHeader: false, showPostFooter: false, showSidebar: false
    }

  }
  ,

  {
    path: 'validateuser',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/resetpassword/resetpassword.module').then(
        m => m.ResetPasswordModule
      ),
    data: {
      title: 'Reset Password', showPreHeader: false, showPostHeader: true, showPostFooter: true, showSidebar: true
    }
  }
  ,

  {
    path: 'activateuser',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/resetpassword/resetpassword.module').then(
        m => m.ResetPasswordModule
      ),
    data: {
      title: 'Activate User', showPreHeader: false, showPostHeader: true, showPostFooter: true, showSidebar: true
    }
  }




  ,

  {
    path: 'webregister',
    loadChildren: () =>
      import('./page/webregister/webregister.module').then(
        m => m.WebRegisterModule
      ),
    data: {
      title: 'Web Register', showPreHeader: true, showPostHeader: false, showPreFooter: true, showPostFooter: false, showSidebar: false
    }
  }
  ,
  {
    path: 'userconfirmation',
    loadChildren: () =>
      import('./page/webregister/confirmation/confirmation.module').then(
        m => m.ConfirmationModule
      ),
    data: {
      title: 'Web Register', showPreHeader: true, showPostHeader: false, showPreFooter: true, showPostFooter: false, showSidebar: false
    }
  }
  ,

  {

    path: 'viewusers',

    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/viewusers/viewusers.module').then(
        m => m.ViewUsersModule
      ),
    data: {
      title: 'View Users', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: true, showSidebar: true
    }
  }


  ,

  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/home/home.module').then(
        m => m.HomeModule
      ),
    data: {
      title: 'Home1', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: true, showSidebar: true
    }
  },
  {
    path: 'qc-data',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/qc-data/qc-data.module').then(
        m => m.QcDataModule
      ),
    data: {
      title: 'QC-DATA', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: false, showSidebar: false
    }
  },
  {
    path: 'qc-data-guidance',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/guidance/guidance.module').then(
        m => m.GuidanceModule
      ),
    data: {
      title: 'GUIDANCE', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: false, showSidebar: false
    }
  },
  {
    path: 'qc-data-view-all-document',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/qc-data/view-all-document/view-all-document.module').then(
        m => m.ViewAllDocumentModule
      ),
    data: {
      title: 'View-All Documents', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: false, showSidebar: false
    }
  },
  {
    path: 'prototype',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/prototype/prototype.module').then(
        m => m.PrototypeModule
      ),
    data: {
      title: 'PROTOTYPE', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: false, showSidebar: false
    }
  },
  {
    path: 'qc-data-proto',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/prototype/qc-data-proto/qc-data-proto.module').then(
        m => m.QcDataProtoModule
      ),
    data: {
      title: 'QC Data', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: false, showSidebar: false
    }
  },
  {
    path: 'view-all-document-proto',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/prototype/view-all-document-proto/view-all-document-proto.module').then(
        m => m.ViewAllDocumentProtoModule
      ),
    data: {
      title: 'View all documents', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: false, showSidebar: false
    }
  },
  {
    path: 'guidance-proto',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/prototype/guidance-proto/guidance-proto.module').then(
        m => m.GuidanceProtoModule
      ),
    data: {
      title: 'Guidance', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: false, showSidebar: false
    }
  },
  {
    path: 'admin-dashboard',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/admin-dashboard/admin-dashboard.module').then(
        m => m.AdminDashboardModule
      ),
    data: {
      title: 'Admin-Dashboard', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: false, showSidebar: false
    }
  },
  {
    path: 'admin-upload-documents-proto',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/prototype/admin-upload-documents-proto/admin-upload-documents-proto.module').then(
        m => m.AdminUploadDocumentsProtoModule
      ),
    data: {
      title: 'Upload Documents', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: false, showSidebar: false
    }
  },
  {
    path: 'admin-dashboard-proto',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/prototype/admin-dashboard-proto/admin-dashboard-proto.module').then(
        m => m.AdminDashboardProtoModule
      ),
    data: {
      title: 'Admin Dashboard', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: false, showSidebar: false
    }
  },
  {

    path: 'weblogin',


    loadChildren: () =>
      import('./page/weblogin/weblogin.module').then(
        m => m.WebLoginModule
      ),
    data: {
      title: 'Web Login', showPreHeader: true, showPostHeader: false, showPreFooter: true, showPostFooter: false, showSidebar: false
    }
  }
  ,

  {

    path: 'resetpassword',


    loadChildren: () =>
      import('./page/resetpassword/resetpassword.module').then(
        m => m.ResetPasswordModule
      ),
    data: {
      title: 'Reset Password', showPreHeader: true, showPostHeader: false, showPreFooter: true, showPostFooter: false, showSidebar: false
    }
  }
  ,

  {

    path: 'webforgotpassword',


    loadChildren: () =>
      import('./page/webforgotpassword/webforgotpassword.module').then(
        m => m.WebForgotPasswordModule
      ),
    data: {
      title: 'Web Forgot Password', showPreHeader: true, showPostHeader: false, showPreFooter: true, showPostFooter: false, showSidebar: false
    }
  }
  ,

  {

    path: 'changepassword',

    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/changepassword/changepassword.module').then(
        m => m.ChangePasswordModule
      ),
    data: {
      title: 'Change Password', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: true, showSidebar: true
    }
  }
  ,

  {

    path: 'updateuser',

    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/updateuser/updateuser.module').then(
        m => m.UpdateUserModule
      ),
    data: {
      title: 'Update User', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: true, showSidebar: true
    }
  }
  ,

  {

    path: 'userrolemap',

    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/userrolemap/userrolemap.module').then(
        m => m.UserRoleMapModule
      ),
    data: {
      title: 'User To Role Mapping', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: true, showSidebar: true
    }
  }
  ,

  {

    path: 'registrationemail',

    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/registrationemail/registrationemail.module').then(
        m => m.RegistrationEmailModule
      ),
    data: {
      title: 'Registration Email', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: true, showSidebar: true
    }
  }
 

  ,

  {

    path: 'roleauthority',

    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/roleauthority/roleauthority.module').then(
        m => m.RoleAuthorityModule
      ),
    data: {
      title: 'Role Authority', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: true, showSidebar: true
    }
  }
  ,

  {

    path: 'userrole',

    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./page/userrole/userrole.module').then(
        m => m.UserRoleModule
      ),
    data: {
      title: 'User Role', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: true, showSidebar: true
    }
  }

  ,
  {
    path: 'weblogin',
    loadChildren: () =>

      import('./page/weblogin/weblogin.module').then(
        m => m.WebLoginModule
      ),
    data: {
      title: 'Login', showPreHeader: false, showPostHeader: false, showPostFooter: false, showSidebar: false
    }
  }
  ,
  {
    path: 'webforgotpassword',
    loadChildren: () =>

      import('./page/webforgotpassword/webforgotpassword.module').then(
        m => m.WebForgotPasswordModule
      ),
    data: {
      title: 'Forgot Password', showPreHeader: false, showPostHeader: false, showPostFooter: false, showSidebar: false
    }
  }
  ,
  {
    path: 'weblogin',
    loadChildren: () =>

      import('./page/weblogin/weblogin.module').then(
        m => m.WebLoginModule
      ),
    data: {
      title: 'Login', showPreHeader: false, showPostHeader: false, showPostFooter: false, showSidebar: false
    }
  }
  ,
  {
    path: 'weblogin',
    loadChildren: () =>

      import('./page/weblogin/weblogin.module').then(
        m => m.WebLoginModule
      ),
    data: {
      title: 'Login', showPreHeader: false, showPostHeader: false, showPostFooter: false, showSidebar: false
    }
  }

  ,
  
  {
    path: 'userroleview',
    loadChildren: () =>
      import('./page/userrole/userroleview.module').then(
        m => m.UserRoleViewModule
      ),
    data: {
      title: 'User To Role Map', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: true, showSidebar: true
    }
  },
  {
    path: 'roleauthorityview',
    loadChildren: () =>
      import('./page/roleauthority/roleauthorityview.module').then(
        m => m.RoleAuthorityViewModule
      ),
    data: {
      title: 'Role To Authority Map', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: true, showSidebar: true
    }
  },
  
  {
    path: 'pdfviewer',
    loadChildren: () =>
      import('./page/pdfviewer/pdfviewer.module').then(
        m => m.PdfviewerModule
      ),
    data: {
      title: 'pdfviewer', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: true, showSidebar: true
    }
  },
  {
    path: 'docdetails/:docId',
    loadChildren: () =>
      import('./page/doc-details/doc-details.module').then(
        m => m.DocDetailsModule
      ),
    data: {
      title: 'docdetails', showPreHeader: false, showPostHeader: true, showPreFooter: false, showPostFooter: true, showSidebar: true
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
